export default {
  unavailable: 'Ten blok nie jest już dostępny i zostanie pominięty w raporcie.',
  onlyIncludedFor: 'Uwzględniany tylko przy eksporcie dla: {scopes}',
  configuration: 'Konfiguracja',
  template: 'Szablon',
  replaced: 'Zastąpiony',
  default: 'Domyślny',
  variables: 'Zmienne',
};
